import type { FolderResponse } from '../api/types'

export interface TreeNode {
  folder: FolderResponse
  children: TreeNode[]
}

/**
 * Builds the tree from the flat list the API returns. A folder whose parent the caller
 * cannot see is shown at the top level: its index number ("2.3.1") says where it sits.
 */
export function buildTree(folders: FolderResponse[]): TreeNode[] {
  const byId = new Map<string, TreeNode>()
  for (const f of folders) byId.set(f.id, { folder: f, children: [] })
  const roots: TreeNode[] = []
  for (const node of byId.values()) {
    const parent = node.folder.parentId ? byId.get(node.folder.parentId) : undefined
    if (parent) parent.children.push(node)
    else roots.push(node)
  }
  const sort = (nodes: TreeNode[]) => {
    nodes.sort(
      (a, b) => a.folder.position - b.folder.position || a.folder.name.localeCompare(b.folder.name),
    )
    for (const n of nodes) sort(n.children)
  }
  sort(roots)
  return roots
}
